// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import type { SumUp } from "./index";

export class APIResource {
  protected _client: SumUp;

  constructor(client: SumUp) {
    this._client = client;
  }
}

// has to be any. the particular query params types don't like unknown
// biome-ignore lint/suspicious/noExplicitAny: any, but only for tests
type QueryParams = Record<string, any>;

type HTTPMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

/**
 * SDK-specific options that can be passed to any generated request method.
 */
export type RequestOptions = {
  /**
   * Optional bearer authorization value to apply to the request, for example
   * `Bearer <access-token>`. When provided, it overrides any default
   * Authorization header configured on the client.
   */
  authorization?: string;
  headers?: HeadersInit;
  host?: string;
  maxRetries?: number;
  signal?: AbortSignal | null;
  timeout?: number;
};

/** All arguments to `request()` */
export type FullRequestOptions = RequestOptions & {
  path: string;
  query?: QueryParams;
  body?: unknown;
  method?: HTTPMethod;
};

export class SumUpError extends Error {}

export class APIError<T> extends SumUpError {
  /* HTTP status for the response that caused the error */
  readonly status: number;
  /* JSON body of the response that caused the error */
  readonly error: T | string;
  /* Raw response of the API */
  readonly response: Response;

  constructor(status: number, error: T | string, response: Response) {
    const message = typeof error === "string" ? error : JSON.stringify(error);
    super(`${status}: ${message}`);
    this.status = status;
    this.error = error;
    this.response = response;
  }
}

export type WithResponse<T> = {
  data: T;
  response: Response;
};

export async function parseResponse<T>(res: Response): Promise<T> {
  if (res.status === 204 || res.status === 205) {
    return undefined as T;
  }

  const contentLength = res.headers.get("content-length");
  if (contentLength === "0") {
    return undefined as T;
  }

  const contentType = res.headers.get("content-type");
  const isJSON = contentType?.includes("json");
  if (!isJSON) {
    throw new SumUpError("Unexpected non-json response.");
  }

  return await res.json();
}
